/* Native disclosures on mobile; desktop content stays expanded. */
(() => {
  if (window.NiralaFooterPanels) return;
  window.NiralaFooterPanels = true;
  const initialize = (scope = document) => {
    const footers = [...scope.querySelectorAll('[data-footer-editor]')];
    if (scope.matches?.('[data-footer-editor]')) footers.unshift(scope);
    footers.forEach((footer) => {
      if (footer.dataset.footerReady) return;
      footer.dataset.footerReady = 'true';
      const panels = [...footer.querySelectorAll('[data-footer-panel]')];
      const mobile = window.matchMedia('(max-width: 800px)');
      const expanded = new WeakMap();
      let accordion = false;
      const synchronize = () => {
        accordion = mobile.matches && footer.dataset.footerMobileLayout === 'accordion';
        panels.forEach((panel) => {
          panel.open = accordion ? expanded.get(panel) === true : true;
          const summary = panel.querySelector('summary');
          if (accordion) {
            summary.removeAttribute('tabindex');
            summary.removeAttribute('aria-disabled');
          } else {
            summary.setAttribute('tabindex', '-1');
            summary.setAttribute('aria-disabled', 'true');
          }
        });
      };
      panels.forEach((panel) => {
        panel.querySelector('summary').addEventListener('click', (event) => {
          if (!accordion) event.preventDefault();
        });
        panel.addEventListener('toggle', () => {
          if (accordion) expanded.set(panel, panel.open);
          else if (!panel.open) panel.open = true;
        });
      });
      synchronize();
      if (mobile.addEventListener) mobile.addEventListener('change', synchronize);
      else mobile.addListener(synchronize);
      footer.addEventListener('shopify:block:select', (event) => {
        event.target.closest('[data-footer-panel]')?.setAttribute('open', '');
      });
      const section = footer.closest('.shopify-section');
      if (section) {
        const unload = (event) => {
          if (event.target !== section) return;
          if (mobile.removeEventListener) mobile.removeEventListener('change', synchronize);
          else mobile.removeListener(synchronize);
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
